var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWithBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "100px",
    height: "100px",
    viewBox: "-0.75 -0.75 3 3",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin",
    className: "jam jam-close",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0.914 0.738 0.442 -0.442A0.125 0.125 0 1 0 1.179 0.119L0.737 0.561 0.295 0.119A0.125 0.125 0 1 0 0.119 0.295l0.442 0.442L0.119 1.179a0.125 0.125 0 1 0 0.177 0.177l0.442 -0.442 0.442 0.442a0.125 0.125 0 1 0 0.177 -0.177L0.914 0.737z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWithBg);
export default __webpack_public_path__ + "static/media/close-with-bg.79d2750c0ddfbf077ede5a347a034916.svg";
export { ForwardRef as ReactComponent };